import { IndeterminateProgressBar } from "@cdkglobal/radial";

export interface ProgressBarProps {
  label: string;
  loaderSize?: "small" | "large";
  trackWidth?: string;
  style?: React.CSSProperties;
  dataTestId?: string;
}

const ProgressBar = ({
  label,
  loaderSize = "large",
  trackWidth = "500px",
  style = { marginTop: "1rem" },
  dataTestId = "indeterminate-progress",
}: ProgressBarProps): JSX.Element => {
  return (
    <IndeterminateProgressBar
      dataTestId={dataTestId}
      label={label}
      loaderSize={loaderSize}
      trackWidth={trackWidth}
      style={style}
    />
  );
};

export default ProgressBar;
